import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import DashboardRoutes from './dashboard';
import SearchRoutes from "./search";
import UserManagementRoutes from './userManagement';
import StudentsRoutes from './students';
import AcademicRoutes from './academic';
import AdminRoutes from './admin';
import BlogRoutes from "./blog"
import SlideRoutes from "./slide"
import EmailRoutes from "./email"
import GalleryRoutes from "./gallery"
import KPIRoutes from "./kpi"
import InvoiceRoutes from "./invoice"
import MessageRoutes from "./message"
import SchedulesRoutes from "./schedules"
import UserAttendanceRoutes from "./userAttendance"
import MarksInputPermissionRoutes from "./MarksInputPermission"
import AttendanceInputPermissionRoutes from "./AttendanceInputPermission"
import ITComponentRoutes from "./IT"
import AdmissionSlideRoutes from "./admissionSlide"
import ResultSlideRoutes from "./resultSlide"
import ResultRoutes from "./result"
import EmployeeSalaryRoutes from "./employeeSalary"
import DomainEmailRoutes from "./domainEmail"
import AppointmentRoutes from "./appointment"
import ResultPublicationRoutes from "./resultPublication"
import HoliDaySMS from "./holiday-sms"
import CTSchedule from "./ct-schedule"
import MCWSchedule from "./mcw-schedule"
import ExamCalendar from "./exam-calendar"
import emailGroup from "./email-group"
import Clubs from "./club"

import withAdminLayout from '../../layout/withAdminLayout';

const Admin = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Suspense
                fallback={
                    <div className="spin">
                        <Spin />
                    </div>
                }
            >
                <Route path={path} component={DashboardRoutes} />
                <Route path={path} component={SearchRoutes} />
                <Route path={`${path}/user-management`} component={UserManagementRoutes} />
                <Route path={`${path}/user-attendance`} component={UserAttendanceRoutes} />
                <Route path={`${path}/students`} component={StudentsRoutes} />
                <Route path={`${path}/academic`} component={AcademicRoutes} />
                <Route path={`${path}/admin`} component={AdminRoutes} />
                <Route path={`${path}/blogs`} component={BlogRoutes} />
                <Route path={`${path}/results`} component={ResultRoutes} />
                <Route path={`${path}/slides`} component={SlideRoutes} />
                <Route path={`${path}/emails`} component={EmailRoutes} />
                <Route path={`${path}/galleries`} component={GalleryRoutes} />
                <Route path={`${path}/kpi`} component={KPIRoutes} />
                <Route path={path} component={InvoiceRoutes} />
                <Route path={path} component={MessageRoutes} />
                <Route path={path} component={SchedulesRoutes} />
                <Route path={path} component={HoliDaySMS} />
                <Route path={path} component={CTSchedule} />
                <Route path={path} component={MCWSchedule} />
                <Route path={path} component={ExamCalendar} />
                <Route path={path} component={MarksInputPermissionRoutes} />
                <Route path={path} component={AttendanceInputPermissionRoutes} />
                <Route path={`${path}/IT`} component={ITComponentRoutes} />
                <Route path={`${path}/admissionSlides`} component={AdmissionSlideRoutes} />
                <Route path={`${path}/resultSlides`} component={ResultSlideRoutes} />
                <Route path={`${path}/employee-salary`} component={EmployeeSalaryRoutes} />
                <Route path={`${path}/domain-emails`} component={DomainEmailRoutes} />
                <Route path={`${path}/appointment`} component={AppointmentRoutes} />
                <Route path={path} component={ResultPublicationRoutes} />
                <Route path={path} component={emailGroup} />
                <Route path={`${path}/clubs`} component={Clubs} />
            </Suspense>
        </Switch>
    );
};

export default withAdminLayout(Admin);